//@ts-ignore
import {ApolloLink, Observable, ServerError} from "@apollo/client/core";
import useAuthenticationStore from "@/shared/stores/authentication.store.ts";
import authenticationService from "@/shared/services/authentication.service.ts";
import {OnBehalfOf} from "@/shared/composable/security.ts";
import router from "@@/router.ts";

//@ts-ignore
const appName = __MODULE__.toString().toUpperCase()

/**
 * In a federated graph, the subgraph's error code is not set on the parent by design because GraphQL supports
 * partially-valid operations. See https://github.com/apollographql/apollo-server/issues/1709.
 */
function isUnauthorizedOperation(apolloResult) {
    return apolloResult?.errors?.find((error) =>
        error?.extensions?.response?.status === 401 ||
        error?.extensions?.exception?.message === "Unauthorized" ||
        error?.extensions?.classification === "UNAUTHORIZED"
    ) !== undefined
}

// naar login als refresh mislukt
export const authRetryLink = new ApolloLink((operation, forward) => {
    //@ts-ignore
    return new Observable(async observer => {

        let salesRep = false

        try {
            const authStore = useAuthenticationStore()
            salesRep = authStore.isSalesRepAccount
        } catch (_) {
            console.log("i18n not set")
        }

        let subscription;

        const onBeHalfOf = operation.getContext()["OnBehalfOf"] as OnBehalfOf | null
        if (onBeHalfOf && salesRep) {
            operation.setContext(({headers = {}}) => ({
                headers: {
                    ...headers,
                    "mcd-on-behalf-of": onBeHalfOf.toString(),
                    "mcd-app": appName,
                },
            }));
        } else {
            operation.setContext(({headers = {}}) => ({
                headers: {
                    ...headers,
                    "mcd-app": appName,
                },
            }));
        }
        const subscriber = {
            next: async (result) => {
                if (isUnauthorizedOperation(result)) {
                    // Try token refresh for unauthorized requests.
                    const authStore = useAuthenticationStore()
                    const success = await authenticationService.refreshToken()
                    if (success) {
                        authStore.authenticated = true
                        // Retry the request, returning the new observable
                        if (subscription) subscription.unsubscribe();
                        subscription = forward(operation).subscribe({
                            next: (result) => observer.next(result),
                            error: (err) => observer.error(err),
                            complete: () => observer.complete(),
                        });
                    } else {
                        authStore.authenticated = false
                        // observer.error(new Error('Token refresh failed'));
                        //Not so nice but can't make it work other way for the moment
                        //Todo here zouden we eigeljk via de logout flow moeten gaan
                        router.push({name: 'login'})
                    }
                } else {
                    observer.next(result)
                }
            },
            error: async (error: ServerError) => {
                if (error.statusCode === 401) {
                    // Try token refresh for unauthorized requests.
                    const success = await authenticationService.refreshToken()
                    if (success) {
                        // Retry the request, returning the new observable
                        subscription = forward(operation).subscribe(observer);
                    }
                } else {
                    // if it's another error, we just forward it
                    observer.error(error)
                }
            },
            complete: async (_) => {
                observer.complete();
            },
        };
        // initial request
        //@ts-ignore
        subscription = forward(operation).subscribe(subscriber);
        return () => {
            if (subscription) subscription.unsubscribe();
        };
    });
});
export default authRetryLink